import { events } from '@cainiaofe/cn-ui-utils';
export function emitEvent(eventName, ...args) {
    if (events && eventName) {
        events?.emit(eventName, ...args);
    }
}
export function onEvent(eventName, func) {
    if (events && eventName && typeof func === 'function') {
        events?.on(eventName, func);
    }
}
/**
 * 页面响应式断点变化时触发
 */
export const CnPageColumnChange = 'L2_CnPageColumnChange';
/**
 * 编辑页面强行重新计算布局事件
 */
export const CnSectionCalculateLayout = 'L2_CnSectionCalculateLayout';
